import { render, staticRenderFns } from "./AuthButton.vue?vue&type=template&id=775f4a1b&scoped=true&"
import script from "./AuthButton.vue?vue&type=script&lang=js&"
export * from "./AuthButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f4a1b",
  null
  
)

export default component.exports